export function AddButton() {
  return (
    <v-btn
      color="primary"
      variant="flat">
      Add
    </v-btn>
  );
}

# Tagging Configuration

This section is where you can configure the Tags.

## Adding Tags

You can add new tags via the <AddButton /> button (bottom right), or edit current tags by clicking on the tag you wish to edit.

## Editing Tags

You can open up the Edit Tag menu by clicking a Tag.

Here you can change a Tags Name and Color.

## Note:

You should **only** change user created tags (the ones with the <v-icon>mdi-tag</v-icon> icon.)

Currently you can break the dynamic tags by changing their names, this should be fixed in future versions.
